import { publishNotes } from "@/mocks/home";

export default function PublishSection() {
  return (
    <section id="publish" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-label rounded-full bg-accent-100 text-accent-800 border border-accent-200">
            <i className="ri-megaphone-line" />
            发布页说明
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            地址为什么会变，发布页又是做什么的
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
            理解地址变化的常见原因，以及发布页在其中承担的作用，能帮助你在遇到访问异常时保持判断，
            不至于因单一地址失效而误判平台状态。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {publishNotes.map((n) => (
            <article
              key={n.title}
              className="flex gap-4 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${n.icon} text-xl`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-950">{n.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{n.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center gap-4 p-5 md:p-6 rounded-lg bg-secondary-100 border border-secondary-200">
          <span className="w-12 h-12 flex items-center justify-center rounded-md bg-background-50 text-secondary-900 border border-secondary-200">
            <i className="ri-lightbulb-line text-2xl" />
          </span>
          <p className="text-sm leading-relaxed text-secondary-900">
            <strong className="font-semibold text-foreground-950">小提示：</strong>
            把发布页或说明页固定收藏，比单纯记住某个地址更可靠。当原地址无法访问时，
            先回到固定收藏的参考页核对，再决定是否更换入口。
          </p>
        </div>
      </div>
    </section>
  );
}